let idCounter = 1

export const generateUniqueId = (): number => {
  return idCounter++
}
